export default function LogoHeader() {
  return (
    <div className="xl:justify-self-start">
      <a href="/">
        <img src="/logo.svg" alt="Logo" className="h-18" />
      </a>
    </div>
  );
}
